var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M500,990c-130.9,0-253.9-51-346.5-143.5C61,753.9,10,630.9,10,500c0-130.9,51-253.9,143.5-346.5C246.1,61,369.1,10,500,10c130.9,0,253.9,51,346.5,143.5C939,246.1,990,369.1,990,500c0,130.9-51,253.9-143.5,346.5C753.9,939,630.9,990,500,990z M500,57.3c-118.3,0-229.4,46-313,129.7C103.3,270.6,57.3,381.7,57.3,500c0,118.3,46,229.4,129.7,313c83.6,83.6,194.8,129.7,313,129.7c118.3,0,229.4-46.1,313-129.7c83.6-83.6,129.7-194.8,129.7-313c0-118.3-46-229.4-129.7-313C729.4,103.3,618.3,57.3,500,57.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691,324.7h-63.2c0-34.9-28.3-63.2-63.2-63.2H438.4c-34.9,0-63.2,28.3-63.2,63.2H312c-34.9,0-63.2,28.3-63.2,63.2v252.7c0,34.9,28.3,63.2,63.2,63.2h379c34.9,0,63.2-28.3,63.2-63.2V387.9C754.2,353,725.9,324.7,691,324.7L691,324.7z M502.5,606.7c-53.3,0-96.6-43.2-96.6-96.6c0-53.3,43.2-96.6,96.6-96.6c53.3,0,96.6,43.2,96.6,96.6C599.1,563.5,555.9,606.7,502.5,606.7L502.5,606.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.63e3636a32f46acf4ccb455bc53da2d6.svg";
export { ForwardRef as ReactComponent };